<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-09 11:05:19
-->
<template>
    <Common>

      <template slot="sz">
          <SzhospitalPayQrCode />
      </template>
      <template slot="hf">
          <SzhospitalPayQrCode />
      </template>
    </Common>
</template>

<script>
import SzhospitalPayQrCode from "@/components/hospitalPayQrCode/szhospitalPayQrCode"
export default{
  components:{
    SzhospitalPayQrCode
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>